export default{
    getProfile: state => state.user,
    isProfileLoaded: state => !!state.user.name,
    isAdm: (state) => {


        let roles =  state.user.roles;

        if(!roles){
            return false;
        }

        var isAdm = false;
        roles.forEach(function(role, index){
            if(role.name === 'ADM'){
               isAdm = true;
               return;
           }
       });
        return isAdm;
    },

    getUserFlags: state => state.userFlags,
    getIsInternational: state => state.userFlags.includes('INTERNATIONAL')
}
